import { render, staticRenderFns } from "./SettleSettings.vue?vue&type=template&id=8608055a"
import script from "./SettleSettings.vue?vue&type=script&lang=js"
export * from "./SettleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports